import AmexExperientialBannerCarouselSlide from './AmexExperientialBannerCarouselSlide';

export default AmexExperientialBannerCarouselSlide;
